import { render, staticRenderFns } from "./NewIncidentMessage.vue?vue&type=template&id=59085f5d&"
import script from "./NewIncidentMessage.vue?vue&type=script&lang=js&"
export * from "./NewIncidentMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports